module.exports = {"attributes":{"width":"19","height":"20","viewBox":"0 0 19 20","xmlns":"http://www.w3.org/2000/svg"},"content":"<g>     <path d=\"M2 18h15V2H2v16zm16 2H1c-.552 0-1-.448-1-1V1c0-.552.448-1 1-1h17c.552 0 1 .448 1 1v18c0 .552-.448 1-1 1z\"/>     <path d=\"M15 7H4V4h11m-6 6H4V8h5m0 5H4v-2h5m0 5H4v-2h5m6-4h-5V8h5m0 5h-5v-2h5m0 5h-5v-2h5\"/>   </g>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/details.svg
// module id = 1397
// module chunks = 0